import React, { useEffect } from "react";
import { Trans } from "@lingui/macro";

import { Spinner } from "widgets/feedback";

import { handleCommunityRedirection } from "./index.js";

import styles from "./style.css";

import KissflowLogoIcon from "../../img/KissflowLogo.svg";

export const CommunityRedirection = () => {
  useEffect(function init() {
    handleCommunityRedirection();
  }, []);

  return (
    <div className={styles.loaderBody}>
      <div className={styles.innerContent}>
        <Spinner />
        <div className={`h4600 ${styles.loaderHeader}`}>
          <Trans>You are being redirected to the Kissflow Community</Trans>
        </div>
        <p className="small400">
          <Trans>This may take a few seconds</Trans>
        </p>
      </div>
      <div className={styles.footerContainer}>
        <KissflowLogoIcon />
        <div className={styles.separatorLine} />
        <span className={`h5 ${styles.communityFooter}`}>
          <Trans>Community</Trans>
        </span>
      </div>
    </div>
  );
};
